import {
  CAMERA_MAX_ZOOM,
  CAMERA_MIN_ZOOM,
  ZOOM_STEP,
} from '@Components/BigBrowse/BigBrowseConfig';
import {
  getEffectForZoomSpan,
  getZoomSpanForZoom,
  useBbContentPresenter,
} from '@Components/BigBrowse/bb2/BbContentPresenter';
import { ZoomMinus, ZoomPlus } from '@Components/Common/Icons/Icon';
import { MINI_MAP_BOTTOM_POSITION } from '@Map/MiniMap2/MiniMap2';
import { useMiniMapWrapperStyle } from '@Map/MiniMap2/useWrapperStyles';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components/native';

import { ZoomButton } from './ZoomButton';

const Wrapper = styled.View`
  position: absolute;
  left: 20px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const MARGIN_FROM_MINIMAP = 10;

export const DesktopZoomPanel = observer(function DesktopZoomPanel() {
  const {
    canvasManager,
    enableSuppressHeroBackgroundFX,
    enableCollapsedDisplaysFX,
  } = useBbContentPresenter();
  const { zoomIn, zoomOut } = canvasManager;

  const { height } = useMiniMapWrapperStyle();
  const bottom = MINI_MAP_BOTTOM_POSITION + height + MARGIN_FROM_MINIMAP;

  const onZoomIn = () => {
    const currentZoomSpan = canvasManager.cameraZoom.value;
    if (currentZoomSpan === CAMERA_MAX_ZOOM) {
      return;
    }

    const targetZoom = Math.min(currentZoomSpan + ZOOM_STEP, CAMERA_MAX_ZOOM);
    const targetZoomSpan = getZoomSpanForZoom(targetZoom);
    const { collapse, noBackground } = getEffectForZoomSpan(targetZoomSpan);
    enableSuppressHeroBackgroundFX.set(noBackground);
    enableCollapsedDisplaysFX.set(collapse);

    zoomIn();
  };
  const onZoomOut = () => {
    const currentZoomSpan = canvasManager.cameraZoom.value;
    if (currentZoomSpan === CAMERA_MIN_ZOOM) {
      return;
    }

    const targetZoom = Math.max(currentZoomSpan - ZOOM_STEP, CAMERA_MIN_ZOOM);
    const targetZoomSpan = getZoomSpanForZoom(targetZoom);
    const { collapse, noBackground } = getEffectForZoomSpan(targetZoomSpan);
    enableSuppressHeroBackgroundFX.set(noBackground);
    enableCollapsedDisplaysFX.set(collapse);

    zoomOut();
  };

  return (
    <Wrapper style={{ bottom }}>
      <ZoomButton onPress={onZoomIn}>
        <ZoomPlus width={18} height={18} />
      </ZoomButton>
      <ZoomButton onPress={onZoomOut}>
        <ZoomMinus width={18} height={2} />
      </ZoomButton>
    </Wrapper>
  );
});
